export default __webpack_public_path__ + "static/media/ddcx.17953e4f.jpg";